import { render, staticRenderFns } from "./ChangeLanguageModal.vue?vue&type=template&id=6978a632&scoped=true&"
import script from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLanguageModal.vue?vue&type=style&index=0&id=6978a632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978a632",
  null
  
)

export default component.exports